module.exports = __webpack_public_path__ + "img/king_charters.38a75e51.webp";